export enum RecipientUnit {
	unknown = 0,
	user,
	group,
	emailAddress,
	orgUnit,
}

export interface IRecipient<T = any> {
	type: RecipientUnit;
	model: T;
}
